import { defineMessages } from 'react-intl';

export default defineMessages({
  processing: {
    id: 'simulated.edition.LoaderRequestReportAccess.processing',
    defaultMessage: 'Processing the request...',
  },
  pleaseWait: {
    id: 'simulated.edition.LoaderRequestReportAccess.pleaseWait',
    defaultMessage: 'Please, wait!',
  },
});